import React, { Component } from "react";
import { Link } from "react-router-dom";
import { TEXT_LABELS } from "../common/configTable";
import MUIDataTable from "mui-datatables";
import { Typography, Tooltip } from "@material-ui/core";
import { People as PeopleIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ThemeContainer from "../common/ThemeProvider";

class ProjectsTable extends Component {
  render() {
    const { datas, onDelete } = this.props;

    const columns = [
      {
        name: "data.count",
        label: "ID",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
        },
      },
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: "excluded",
        },
      },
      {
        name: "slug",
        label: "slug",
        options: {
          filter: false,
          display: "excluded",
        },
      },
      {
        name: "updated_at",
        label: "Fecha Actualización",
        options: {
          filter: false,
          display: "excluded",
        },
      },
      {
        name: "code",
        label: "Código",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "name",
        label: "Nombre",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={`/proyecto/${tableMeta.rowData[2]}`}
              >
                {value}
              </Link>
            );
          },
        },
      },
      {
        name: "startDate",
        label: "Fecha Inicio",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "endDate",
        label: "Fecha Final",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "endDateReal",
        label: "Fecha Prórroga",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "project_type.name",
        label: "Tipo",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "research_type.name",
        label: "Tipo de Investigación",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "coverage_type.name",
        label: "Cobertura",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "human_updated_at",
        label: "Última Actualización",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <React.Fragment>
                <Tooltip
                  title={`${tableMeta.rowData[3]}`}
                  style={{ cursor: "pointer" }}
                >
                  <span>{`${value}`}</span>
                </Tooltip>
              </React.Fragment>
            );
          },
        },
      },
      {
        name: "",
        label: "Acciones",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <React.Fragment>
                <Tooltip title="Editar" style={{ cursor: " ointer" }}>
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/proyecto/${tableMeta.rowData[2]}`}
                  >
                    <EditIcon color={"primary"} />
                  </Link>
                </Tooltip>
                <Tooltip title="Miembros" style={{ cursor: "pointer" }}>
                  <Link
                    style={{ textDecoration: "none", color: "#fff" }}
                    to={`/proyecto/${tableMeta.rowData[2]}/miembros`}
                  >
                    <PeopleIcon color={"primary"} />
                  </Link>
                </Tooltip>
                <Tooltip title="Eliminar" style={{ cursor: "pointer" }}>
                  <DeleteIcon
                    onClick={() => onDelete(tableMeta.rowData[2])}
                    color={"primary"}
                  />
                </Tooltip>
              </React.Fragment>
            );
          },
        },
      },
    ];
    const options = {
      /* search: false,
      print: false,
      download: false,
      filter: false,
      viewColumns: false, */
      enableNestedDataAccess: ".",
      sort: true,
      searchPlaceholder: "Buscar",
      filterType: "dropdown",
      responsive: "scroll",
      rowsPerPage: 20,
      rowsPerPageOptions: [5, 10, 20],
      selectableRows: "none",
      textLabels: TEXT_LABELS,
      //selectableRows: "single",
      /* onRowsDelete: (rowsDeleted) => {
        const items = datas; //lista de todos los proyectos
        const itemsToDelete = rowsDeleted.data.map(
          (item) => items[item.dataIndex]
        ); //Array de todos los proyectos a borrar.
        this.props.onDelete(itemsToDelete);
      }, */
    };
    return (
      <ThemeContainer>
        <MUIDataTable
          title={<Typography variant="h6">Lista de proyectos</Typography>}
          data={datas}
          columns={columns}
          options={options}
          responsive={"scrollFullHeight"}
        />
      </ThemeContainer>
    );
  }
}

export default ProjectsTable;
